
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import image1 from "../img/tradly/refurbish-Manufacture.png"
import image2 from "../img/tradly/Recycle-Smart-Apps-solution-1024x373.png"
 

import Resources from './_resources.mdx';
import Checklist from './_checklist.mdx';
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Here is the toolkit to develop your Gym Fitness Marketplace Platform, and Apps",
  "date": "2021-05-30"
};
const slug = 'gym-fitness-marketplace-app';
const tableOfContents = [];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <p>{`Looking to build gym fitness marketplace and apps? Here is the toolkit to launch without writing a single line of code, faster. No code builder and Toggle based feature activating. White label. Open source web app template to get started.`}</p>
    <p>{`Looking build your own marketplace app without writing a line of code. `}<a parentName="p" {...{
        "href": "https://tradly.app/signup"
      }}>{`Click here…`}</a></p>
    <Checklist mdxType="Checklist" />
    <Resources mdxType="Resources" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
